import React from 'react';
import Navbar from './Navbar';
import RenterTopNav from './RenterTopNav';
import DashboardSwitcher from './DashboardSwitcher';
import Footer from './Footer';

const RenterLayout = ({ activePage, title, description, actions, compact = false, account = false, children }) => {
  return (
    <div className="min-h-screen bg-[#F3F4F6] font-sans text-brand-black flex flex-col">
      <Navbar />

      <main className="flex-grow">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 lg:py-10 pb-20">
          <section className="rounded-[2rem] bg-white border border-gray-100 shadow-sm overflow-hidden">
            <div className={`px-5 lg:px-8 ${compact ? "py-6 bg-orange-50/40" : "py-8 bg-stone-50"} border-b border-gray-100`}>
              <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6">
                <div>
                  <p className="text-[10px] font-black uppercase tracking-[0.24em] text-gray-400 mb-3">
                    {account ? 'Your account' : 'Renter Portal'}
                  </p>
                  <h1 className={`${compact ? "text-2xl lg:text-3xl" : "text-3xl lg:text-4xl"} font-bold tracking-tight mb-2`}>{title}</h1>
                  {description ? (
                    <p className="text-sm lg:text-base text-gray-500 font-medium max-w-3xl">
                      {description}
                    </p>
                  ) : null}
                </div>
                {actions ? <div className="shrink-0">{actions}</div> : null}
              </div>
            </div>

            <div className={`px-5 lg:px-8 ${compact ? "py-5" : "py-8"}`}>
              <div className="mb-4"><DashboardSwitcher active={account ? (activePage === 'Settings' ? '/account/settings' : '/account/notifications') : '/renter-dashboard'} /></div>
              {!account && <RenterTopNav activePage={activePage} />}
              {children}
            </div>
          </section>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default RenterLayout;
